<script setup lang="ts">
defineProps<{
  loading: boolean;
  /** What is being waited for, for screen readers. */
  label?: string;
}>();
</script>
<template>
  <div
    v-if="loading"
    class="loader-container"
    role="status"
    :aria-label="label || 'Loading'"
  >
    <div
      class="spinner"
      aria-hidden="true"
    />
  </div>
</template>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0f4d90;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
